<template>
    <div class="edc-modal">
        <SOSlotModal :modal-title="mTitle" :modal-id="modalId" @close="back">
            <template v-slot:modal-body>
                <div class="p-t-8">
                    Anda akan mengirim ulang sebanyak {{ totalMsg }} pesan, pengiriman ini akan memotong
                    {{ totalMsg }} Quota pesan atau {{ totalMcoin }} M-koin jika berhasil dikirim semua. Pastikan Quota
                    Pesan atau M-koin anda mencukupi.
                </div>
            </template>
            <template v-slot:modal-footer>
                <div>
                    <div style="margin-bottom: 10px">
                        <SOButton
                            :outline-danger="true"
                            :full="true"
                            :text="'Ya, Kirim ulang'"
                            :id="'confirm-resend'"
                            :disable="isFetching"
                            :loading="isFetching"
                            @action="onConfirm"
                        />
                    </div>
                    <div>
                        <SOButton
                            :outline="true"
                            :full="true"
                            :text="'Batal'"
                            :id="'batal-confirm-resend'"
                            :disable="isFetching"
                            :loading="isFetching"
                            @action="back"
                        />
                    </div>
                </div>
            </template>
        </SOSlotModal>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotModal from "@/so-components/global/slot/SOSlotModal.vue";
import SOButton from "@/so-components/global/ui/SOButton";
import resulter from "@/store/utils/resulter";

import { moduleName } from "../../store/state";

export default {
    name: "ConfirmResendMessage",
    components: {
        SOSlotModal,
        SOButton,
    },
    data() {
        return {
            backLink: "wa_autosender.detail_perangkat.riwayat_pesan",
            modalId: "modal-confirm-resend-msg",
        };
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.setBackLink(from.name);
        });
    },
    beforeRouteLeave(to, from, next) {
        this.closeModal();
        next();
    },
    mounted() {
        $(`#${this.modalId}`).modal("show");
    },
    computed: {
        ...mapGetters(moduleName, {
            isFetching: "isFetching",
            customer: "customer",
        }),
        totalMsg() {
            return parseInt(this.$route.query?.countMsg || 0);
        },
        totalMcoin() {
            let mcoin = this.totalMsg * 100;
            return mcoin.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        mTitle() {
            return `Kirim ulang ${this.totalMsg} pesan yang gagal`;
        },
        getIdDevice() {
            return this.$route.params.id_device;
        },
        getNumber() {
            return this.customer.number;
        },
    },
    methods: {
        ...mapActions({
            setFetching: `${moduleName}/setFetching`,
            setResponse: `${moduleName}/setResponse`,
            resendAllMessage: `${moduleName}/resendAllMessage`,
            resetListPesan: `${moduleName}/resetListPesan`,
            resetPagePesan: `${moduleName}/resetPagePesan`,
            getHistoryPesanV2: `${moduleName}/getHistoryPesanV2`,
        }),
        async back() {
            await this.$router.push({ name: this.backLink});
        },
        closeModal() {
            $(`#${this.modalId}`).modal("hide");
        },
        setBackLink(val) {
            this.backLink = val;
        },
        async reloadList() {
            await this.resetPagePesan();
            await this.resetListPesan();
            await this.getHistoryPesanV2({
                idMesin: this.getIdDevice,
                nomor: this.getNumber !== "all" ? this.getNumber : "",
            });
        },
        onConfirm() {
            let { number } = this.customer;
            let payload = {
                idMesin: this.getIdDevice,
                nomor: number ? number : "",
            };

            this.resendAllMessage(payload)
                .then((res) => {
                    if (!res.data) {
                        this.$toast.error(res);
                    } else {
                        let { code, status, msg, data } = res.data;
                        if (status && code === 200) {
                            this.setResponse(resulter.successResult(msg));
                            this.$toast.success(msg);
                            this.reloadList();
                            this.back();
                        } else {
                            this.setResponse(resulter.errorResult(msg));
                            this.$toast.error(msg);
                        }
                    }
                    this.setFetching(false);
                })
                .catch((e) => {
                    this.setFetching(false);
                    this.$toast.error(e);
                    this.setResponse(resulter.errorResult(e));
                });
        },
    },
};
</script>
